<template>
  <div class="w-full h-full">
    <div class="relative flex flex-col w-full h-full">
      <two-blocks-layout :navigate="navigate" v-bind="page" class="my-auto">
        <span
          class="text-outline text-title-md"
          v-text="`${page.titolo1} `"
        /><br />
        <span class="text-title-md " v-text="page.titolo2" />
      </two-blocks-layout>
      <app-cta-button
        cta
        mobile-only
        full-width
        :link="apriContoUrl"
        external
        button-style="brand"
      />
    </div>
    <!-- <div class="parallax absolute inset-0 flex items-center justify-center">
      <img class="max-h-96" src="/img/bubble.png" />
    </div> -->
  </div>
</template>

<script>
import { axios } from "@/plugins/axios";
import TwoBlocksLayout from "@/components/page-layouts/TwoBlocksLayout.vue";

export default {
  components: { TwoBlocksLayout },
  props: { navigate: { default: null } },
  async beforeRouteEnter(to, from, next) {
    let page;
    try {
      page = await axios.get(`/pageContent${to.path}.json`);
    } catch (error) {
      page = {};
    } finally {
      next(vm => (vm.page = page.data));
    }
  }
};
</script>
<route>
{
  "name": "Internet Banking",
  "meta": {
      "order": 6,
      "label": "Internet Banking"
  }
}
</route>
